export enum SignUpFlowType {
  SIGN_UP = 'sign_up',
  VERIFY_EMAIL = 'verify_email',
  VERIFY_PHONE = 'verify_phone',
  RESEND_EMAIL_OTP = 'resend_email_confirmation',
  FORGOT_PASSWORD = 'forgot_password',
  CONFIRM_PASSWORD = 'confirm_password',
  SEND_EMAIL_OTP = 'send_email_otp',
  SEND_PHONE_OTP = 'send_phone_otp',
}

export interface SignUpFlowData {
  username: string;
  phone_number?: string;
  password?: string;
  otp_value?: string;
  update_flag?: boolean;
  updated_value?: string;
  user_id?: string;
}

export interface LoginData {
  username: string;
  password?: string;
  auth_type?: 'otp' | 'verify_auth_otp';
  session?: string;
  otp_value?: string;
  user_id?: string;
  channel?: OTPChannel;
}

export interface ResetPasswordData {
  username: string;
  password: string;
  session: string;
}

export interface LoginResponse {
  data: string;
  is_verified: boolean;
  expiry_time: string;
  generation_time: string;
  email_verification_flag?: boolean;
  error?: string;
  phone_number?: string;
  phone_verification_flag?: boolean;
  user_id?: string;
  user_name?: string;
  is_hsbc_number_verified?: boolean;
}

export interface LoginOTPResponse {
  otp_sent: boolean;
  session: string;
  user_name: string;
  user_id: string;
  is_verified?: boolean;
  error?: string;
  user_password?: boolean;
}

export type LoginOTPPayload = {
  username: string;
  type?: 'login';
  channel?: OTPChannel;
};

export type VerifyLoginOTPPayload = {
  username: string;
  session: string;
  otp_value: string;
  type?: 'login';
  channel?: OTPChannel;
};

interface LoginVerifyErrorResponse {
  session: string;
  user_name: string;
}

export type LoginSuccessResponse = {
  data: string;
  is_verified: boolean;
  generation_time: string;
  expiry_time: string;
  user_id: string;
  user_name: string;
  phone_number: string;
  phone_verification_flag: boolean;
  email_verification_flag: boolean;
  user_password: boolean;
};

export type VerifyLoginOTPResponse =
  | LoginVerifyErrorResponse
  | LoginSuccessResponse;

export type SignUpPayload = {
  username: string;
  password: string;
  phone_number: string;
};

export interface SignUpSuccessResponse {
  data: string;
  user_id: string;
  email_verification_flag: boolean;
  phone_verification_flag: boolean;
}

export type OTPChannel = 'sms' | 'whatsapp';
